import { Modal, Table, Badge, Alert } from "react-bootstrap";
import { format } from 'date-fns';
import { useAppSelector } from "../../../../../redux/hooks";
import { ReducerEnum, setClientPortalModalType } from "../../../../../redux/reducer";
import { ClientPortalModalType } from "../../../types";
import { useClientInformation } from '../../../hooks/useClientInformation';
import { useRetainerInformationQuery } from '../../../hooks/useRetainerInformationQuery';


export type ClientRetainerTaskModalProps = {
    dispatch: (arg0: {
        type: ReducerEnum;
        payload: any;
        key?: string;
        extraPayload?: Record<string, string>;
    }) => void;
}

const ClientRetainerTaskModal = (props: ClientRetainerTaskModalProps) => {

    const show: boolean = useAppSelector((state) => state.ClientPortalState?.ModalType === ClientPortalModalType.CLIENT_RETAINER);

    const { data: clients = [] } = useClientInformation(show);
    const { isRetainerRequired } = useRetainerInformationQuery(show);
    

    return (
        <>
            <Modal
                show={show}
                onHide={() => { props.dispatch(setClientPortalModalType(ClientPortalModalType.NONE)) }}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="modal-list"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">Client Retainer Status</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {isRetainerRequired ?
                        (
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Client</th>
                                        <th>Status</th>
                                        <th>Date Signed</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {clients ?
                                        <>
                                            {clients.map((client, index) => (
                                                <tr key={index}>
                                                    <td>{client.Name}</td>
                                                    <td>{client.RetainerAcknowledged ? <Badge bg="success" text="dark" pill>Signed</Badge> : <Badge bg="secondary" text="dark" pill>Not Signed</Badge>} </td>
                                                    <td>
                                                        {client.RetainerAcknowledged && client.RetainerAcknowledgedDateTime ? (
                                                            <Badge pill text="dark" bg="info">
                                                                {format(new Date(client.RetainerAcknowledgedDateTime), "MMMM do, yyyy 'at' h:mm a")}
                                                            </Badge>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </td>
                                                </tr>
                                            )

                                            )}
                                        </>
                                        :
                                        <></>
                                    }
                                </tbody>
                            </Table>
                        )
                        :
                        (
                            <>
                                <Alert style={{margin:"20px"}}>Retainer not Required</Alert>
                            </>
                        )
                    }
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ClientRetainerTaskModal;
